import jwt_decode from "jwt-decode";
import { getSessionToken } from "../lib/sessionToken";
import { setPylonHiddenFromAT } from "../lib/pylonA11y";

const PYLON_APP_ID =
  process.env.REACT_APP_PYLON_APP_ID || "6000e45a-6b53-4401-93b4-a8d408e9b062";
const CHAT_USER_EMAIL_KEY = "userEmail";
const CHAT_USER_HASH_KEY = "pylonEmailHash";

const decodeEmailFromToken = () => {
  const token = getSessionToken();
  if (!token) return "";

  try {
    const decodedToken = jwt_decode(token);
    return decodedToken?.user?.email || decodedToken?.email || "";
  } catch (err) {
    return "";
  }
};

const buildChatSettings = ({ email, name, emailHash } = {}) => {
  const resolvedEmail = (
    email ||
    localStorage.getItem(CHAT_USER_EMAIL_KEY) ||
    decodeEmailFromToken() ||
    ""
  )
    .trim()
    .toLowerCase();
  const resolvedName = (name || localStorage.getItem("userName") || "").trim();
  const resolvedHash = (
    emailHash ||
    localStorage.getItem(CHAT_USER_HASH_KEY) ||
    ""
  ).trim();

  return {
    app_id: PYLON_APP_ID,
    ...(resolvedEmail ? { email: resolvedEmail } : {}),
    ...(resolvedName ? { name: resolvedName } : {}),
    ...(resolvedHash ? { email_hash: resolvedHash } : {}),
  };
};

export const setPylonChatUser = ({ email, name, emailHash } = {}) => {
  const resolvedEmail = (
    email ||
    localStorage.getItem(CHAT_USER_EMAIL_KEY) ||
    decodeEmailFromToken() ||
    ""
  )
    .trim()
    .toLowerCase();
  const resolvedHash = (
    emailHash ||
    localStorage.getItem(CHAT_USER_HASH_KEY) ||
    ""
  ).trim();
  if (resolvedEmail) {
    localStorage.setItem(CHAT_USER_EMAIL_KEY, resolvedEmail);
  }
  if (resolvedHash) {
    localStorage.setItem(CHAT_USER_HASH_KEY, resolvedHash);
  }

  window.pylon = {
    chat_settings: buildChatSettings({
      email: resolvedEmail,
      name,
      emailHash: resolvedHash,
    }),
  };
};

export const ensurePylonChatUser = () => {
  const existingSettings = window?.pylon?.chat_settings || {};

  const hasRequiredSettings =
    Boolean(existingSettings?.app_id) &&
    Boolean(existingSettings?.email) &&
    Boolean(existingSettings?.name);

  if (!hasRequiredSettings) {
    setPylonChatUser({
      email: existingSettings.email,
      name: existingSettings.name,
      emailHash: existingSettings.email_hash,
    });
  }
};

export const showPylonChatBubble = () => {
  ensurePylonChatUser();
  if (window?.Pylon) {
    window.Pylon("showChatBubble");
  }
};

export const closePylonChat = () => {
  if (window?.Pylon) {
    window.Pylon("hide");
  }
  document.body.classList.remove("pylon-chat-open");
  setPylonHiddenFromAT(true);
};

export const openPylonChat = () => {
  ensurePylonChatUser();
  if (window?.Pylon) {
    // Ensure tutorial launcher shifts immediately on any open source.
    document.body.classList.add("pylon-chat-open");
    // The closed widget is inert, so lift that before Pylon renders into it.
    setPylonHiddenFromAT(false);
    // Note: "show" also re-enables Pylon's own bubble, and "hideChatBubble"
    // would close the window again, so the bubble is suppressed via CSS
    // (.PylonChat-bubbleFrameContainer in index.css) instead.
    window.Pylon("show");
  }
};
